// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_2 from '/Users/a1804491927/Code/ben_ai/benai-admin/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from '/Users/a1804491927/Code/ben_ai/benai-admin/src/models/useProjectSettings';

export const models = {
model_2: { namespace: '@@initialState', model: model_2 },
model_1: { namespace: 'useProjectSettings', model: model_1 },
} as const
